
import React, { useState } from "react";
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import Form from '@synergycms_core/components/generic/Form';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import InputField from '@synergycms_core/components/generic/Form/InputField';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';

import actions from '../../../../store/actions';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';


const LoyaltyFormLogin = ({ onView, login, hotelConfig, langCode, classes  }) => {


  const forgot_password_url = hotelConfig.getIn(['fideltour','fildetour_forgot_password_url', langCode,'translatable_value'], "total");
  
  const [error, setError] = useState(false);

  const handleSubmit = (validForm, inputList) => {
    setError(false);

    if(!validForm) {
      return Promise.reject();
    }

    return login(inputList).then(() => {
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    }).catch((e)=>{
      setError(e.message);
    });
  };

  return (
    <>
      <div className={[classes.loginCustomerForm].join(' ')}>
        <Form id="RegisterForm" disableLoading={true} onSubmit={handleSubmit} innerStyle={[classes.customerForm, classes.loyaltyForm].join(' ')}>
          <label className={classes.inputBox} useref={'username'}>
            <InputField model={'username'} innerStyle={['inputText', classes.inputText]} validationsFields={{ field: 'username' }}
                        validations={[ 'required', 'email' ]}/>
            <InputNotify model={'username'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%email fidelizacion%_'} translate={true}/>
          </label>
          <label className={classes.inputBox} useref={'password'}>
            <InputField model={'password'} type={'password'} innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]} validationsFields={{ field: 'password' }}
                        validations={['required', { type: 'maxLength', maxLength: 16 }, { type: 'minLength', minLength: 8 } ]}/>
            <InputNotify model={'password'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%contrasena fidelizacion%_'} translate={true} />
          </label>
          <div className={classes.containerBtnsLoyalty}>
            <ButtonSubmit richText={{ text: '_%login fidelizacion%_', translate: true, ucFirst: true, innerStyle:['uppercase'] }} innerStyle={[ classes.loginLoyaltyBtn, 'toggleSecondButton']}/>
            {forgot_password_url &&
              <Button
                onClick={() => window.open(forgot_password_url, '_blank')}
                richText={{ text: '_%recuperar contraseña%_', translate: true, ucFirst: true, innerStyle:['blue'] }}
                innerStyle={[classes.forgotPassword]}
              />
            }
          </div>
          { error && <RichText innerStyle={[classes.errorText]} text={error} translate={true} /> }
        </Form>
      </div >
      
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    login: (inputList) => {
      return dispatch(actions.customer.loyalty.login(inputList));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);

  return {
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    hotelConfig :contextualizeAppConfig(store, hotelId),
    classes: ownProps.classes
  }
};


export default compose(connect(mapStateToProps, mapDispatchToProps), withContent('i18n'))(LoyaltyFormLogin);